/* Wait for Shopify's restored content, not a fixed welcome-screen delay.
   Only public readiness events and the outer shadow DOM are observed. */
(() => {
  if (window.waChatLayoutStarted) return;
  window.waChatLayoutStarted = true;
  const roots = new WeakSet(), hosts = new WeakSet(), states = new WeakMap();
  function finish(host, reason) {
    const state = states.get(host);
    if (!state || state.done) return;
    state.done = true;
    clearTimeout(state.failsafe); clearTimeout(state.compatibility);
    state.frame.style.visibility = state.visibility;
    state.status?.remove();
    host.dataset.waChatLayout = 'ready';
    host.dataset.waChatReadyReason = reason;
    host.dataset.waChatLoadingMs = String(Math.round(performance.now() - state.started));
    host.removeAttribute('aria-busy');
  }
  function ready(host) {
    const state = states.get(host);
    if (!state || state.done) return;
    if (state.restored || (state.loaded && host.hasAttribute('shell-ready'))) {
      if (state.paintQueued) return;
      state.paintQueued = true;
      requestAnimationFrame(() => requestAnimationFrame(() => finish(host, state.restored ? 'native-restored' : 'native-first-paint')));
    } else if (!state.compatibility && (state.loaded || host.hasAttribute('shell-ready'))) {
      // Future native versions may omit the event: never lock the native UI away.
      state.compatibility = setTimeout(() => finish(host, 'compatibility-timeout'), 1500);
    }
  }
  function restored(host) {
    const state = states.get(host);
    if (!state || state.done) return;
    state.restored = true; ready(host);
  }
  function note(frame) {
    const body = frame.parentElement;
    if (!body) return null;
    const status = document.createElement('div');
    status.className = 'wa-chat-loading'; status.setAttribute('role', 'status');status.setAttribute('aria-live', 'polite');
    const label = document.createElement('span');
    label.textContent = document.documentElement.lang.toLowerCase().startsWith('de') ? 'Deine Beratung wird geladen …' : 'Loading your whisky assistant …';
    const dots = document.createElement('span'); dots.className = 'wa-chat-loading-dots';dots.setAttribute('aria-hidden','true');
    status.append(dots,label);
    const style = document.createElement('style');
    style.textContent = '.wa-chat-loading{position:absolute;inset:0;z-index:3;background:#fff;display:flex;flex-direction:column;align-items:center;justify-content:center;gap:16px;color:#52645f;font-family:inherit;font-size:13px;font-weight:400;line-height:1.6;text-align:center;padding:24px;pointer-events:none}.wa-chat-loading-dots{width:22px;height:22px;border:2px solid #e4e9e5;border-top-color:#806a43;border-radius:50%;animation:wa-chat-load .8s linear infinite}@keyframes wa-chat-load{to{transform:rotate(360deg)}}@media(prefers-reduced-motion:reduce){.wa-chat-loading-dots{animation:none}}';
    status.append(style);body.append(status);return status;
  }
  function frameReady(frame, host) {
    let previous = states.get(host);
    if (previous?.frame === frame) return;
    if (previous) {clearTimeout(previous.failsafe);clearTimeout(previous.compatibility);previous.status?.remove();}
    const state = {frame,visibility:frame.style.visibility,done:false,restored:false,started:performance.now(),status:null,paintQueued:false,compatibility:null,failsafe:null};
    states.set(host,state);
    frame.style.visibility = 'hidden';state.status = note(frame);
    host.dataset.waChatLayout = 'pending';host.setAttribute('aria-busy','true');
    state.failsafe = setTimeout(() => finish(host,'fail-open'),2500);
    frame.addEventListener('load',()=>{state.loaded=true;ready(host);},{once:true});ready(host);
  }
  function watch(root, host) {
    if (!root || roots.has(root)) return;roots.add(root);
    root.addEventListener('shopify-chat:restored',()=>restored(host));
    root.addEventListener('shopify-chat:error',()=>finish(host,'native-error'));
    const sync = () => {
      root.querySelectorAll('shopify-agent-runtime').forEach(runtime=>{
        if(runtime.shadowRoot)watch(runtime.shadowRoot,host);
        else customElements.whenDefined('shopify-agent-runtime').then(()=>watch(runtime.shadowRoot,host));
      });
      root.querySelectorAll('iframe').forEach(frame=>frameReady(frame,host));
    };
    new MutationObserver(sync).observe(root,{childList:true,subtree:true});sync();
  }
  function discover() {
    document.querySelectorAll('shopify-chat').forEach(host=>{
      if(!hosts.has(host)){
        hosts.add(host);
        new MutationObserver(()=>ready(host)).observe(host,{attributes:true,attributeFilter:['shell-ready']});
        host.addEventListener('shopify-chat:restored',()=>restored(host));
        host.addEventListener('shopify-chat:error',()=>finish(host,'native-error'));
      }
      if(host.shadowRoot)watch(host.shadowRoot,host);
      else customElements.whenDefined('shopify-chat').then(()=>watch(host.shadowRoot,host));
    });
  }
  new MutationObserver(discover).observe(document.documentElement,{childList:true,subtree:true});discover();
})();

